import { apiClient } from './client';
import type { ApiResponse } from '@/types/api.types';
import type {
  RoleDto,
  RoleSummaryDto,
  PermissionItemDto,
  PermissionGroupDto,
  CreateRoleRequest,
  UpdateRoleRequest,
  UpdateRolePermissionsRequest,
} from '@/types/role.types';

export const roleApi = {
  /** GET /api/v1/roles — all roles visible to caller's company */
  getList: () =>
    apiClient.get<ApiResponse<RoleSummaryDto[]>>('/roles'),

  /** GET /api/v1/roles/{id} — full role with permissions */
  getById: (id: string) =>
    apiClient.get<ApiResponse<RoleDto>>(`/roles/${id}`),

  /** POST /api/v1/roles — create a new company-scoped role */
  create: (data: CreateRoleRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/roles', data),

  /** PUT /api/v1/roles/{id} — update role name and description */
  update: (id: string, data: UpdateRoleRequest) =>
    apiClient.put<ApiResponse<object>>(`/roles/${id}`, data),

  /** DELETE /api/v1/roles/{id} — soft-delete (non-system roles only) */
  remove: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/roles/${id}`),

  /** PUT /api/v1/roles/{id}/permissions — replace full permission set */
  updatePermissions: (id: string, data: UpdateRolePermissionsRequest) =>
    apiClient.put<ApiResponse<object>>(`/roles/${id}/permissions`, data),
};

export const permissionApi = {
  /** GET /api/v1/permissions — flat list of all active permissions */
  getAll: () =>
    apiClient.get<ApiResponse<PermissionItemDto[]>>('/permissions'),

  /** GET /api/v1/permissions/grouped — permissions grouped by module */
  getGrouped: () =>
    apiClient.get<ApiResponse<PermissionGroupDto[]>>('/permissions/grouped'),
};
